import React, { Component } from 'react';
import CompanyListItem from "../../../Registration/RegistrationJuridicalAsan/SelectCompany/CompanyListItem/CompanyListItem";
import { translate } from 'react-i18next';
import { request } from '../../../../config'

class SetCompany extends Component {
    state = {
        companies: null,
        compId: null,
        taxNo: null,
        feedbackMessage: null,
        isDisabled: true
    }

    updateCheckedCompany = (token, taxNo) => {
        this.setState({ isDisabled: false });
        this.setState({ compId: token, taxNo: taxNo });
    }

    getCustCompany = (event) => {
        event.preventDefault();
        this.props.updateAppState('isLoadingTransparentBackground', true);
        this.setState({ feedbackMessage: null });
        let getCustCompanyRequestBody = {
            mobile: this.props.location.state.mobile,
            userId: this.props.location.state.userId,
            token: this.state.compId,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        };
        fetch(request("register/getCustomerCompany", getCustCompanyRequestBody))
            .then(json => json.text())
            .then(getCustCompanyResponse => {
                const JSON = require('true-json-bigint');
                let getCustCompanyResponseObject = JSON.parse(getCustCompanyResponse);
                if (getCustCompanyResponseObject.status.statusCode === 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.history.push('/sign-up/not-a-bank-customer', { success: true });
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ feedbackMessage: this.props.t(getCustCompanyResponseObject.status.statusCode) });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount = () => {
        if (this.props.location.state === undefined) {
            this.props.history.push('/sign-up/not-a-bank-customer/juridical/asan');
        }
        else {
            this.setState({ companies: this.props.location.state.companies })
        }
    }

    render() {
        let { isDisabled, feedbackMessage, companies, compId } = this.state;
        let { t } = this.props;
        return (
            <form className="registration-companies-container-sign-up">
                <div className="registration-companies-container-sign-up-header">
                    <h2 className="registration-container-title">{t('choose a company')}</h2>
                    <p className="registration-container-description">{t('please select the company you want to register')}</p>
                </div>
                <div className="registration-companies-container-sign-up-content">
                    <ul className="registration-companies-container-list">
                        {
                            companies !== null ?
                                companies.map(comp => <CompanyListItem key={comp.token} companyId={comp.token} companyName={comp.name} companyTaxNo={comp.taxNo} updateCheckedCompany={this.updateCheckedCompany} compIdResponse={compId} />)
                                :
                                null
                        }
                    </ul>
                    <div className="registration-container-validation-feedback">
                        {
                            feedbackMessage ? <p className="registration-container-validation-feedback-message">{feedbackMessage}</p> : null
                        }
                    </div>
                </div>
                <div className="registration-companies-container-sign-up-footer">
                    <button className="registration-container-footer-button registration-container-footer-button--right" disabled={isDisabled} onClick={this.getCustCompany}>{t('continue')}</button>
                </div>
            </form>
        )
    }
}


export default translate("translation")(SetCompany);